import { render, staticRenderFns } from "./ModalTutoAction.vue?vue&type=template&id=37f0de15&scoped=true&"
import script from "./ModalTutoAction.vue?vue&type=script&lang=js&"
export * from "./ModalTutoAction.vue?vue&type=script&lang=js&"
import style0 from "./ModalTutoAction.vue?vue&type=style&index=0&id=37f0de15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f0de15",
  null
  
)

export default component.exports